import QX_ASSET_MAPPING from "./quatrix";
import PONTY_ASSET_MAPPING from "./ponty";

export default process.env.REACT_APP_COMPANY === "quatrix"
  ? QX_ASSET_MAPPING
  : process.env.REACT_APP_COMPANY === "ponty"
  ? PONTY_ASSET_MAPPING
  : {};
